module.exports = __webpack_public_path__ + "img/blend1icon3.a96d14e8.png";